export enum CallType {
  Incoming = "incoming",
  Outgoing = "outgoing",
  Followup = "followup",
}
